import React from "react";
import {Col, FormGroup, FormControl } from "react-bootstrap";
import PillInput from "../../../common/pill_input/main";
import ReactDOM from "react-dom";

export default class CustomFieldKeyConfiguration extends React.Component {
  get name() {
    return this.props.name;
  }

  get allowedValues() {
    return this.props.allowedValues;
  }

  updateName(event) {
    let name = event.target.value;
    let allowedValues = this.allowedValues;
    let { index } = this.props;
    this.props.updateCustomField(index, name, allowedValues);
  }

  updateAllowedValues(pillState) {
    let name = this.name;
    let allowedValues = pillState.pills;
    let { index } = this.props;
    this.props.updateCustomField(index, name, allowedValues);
  }

  removeCustomField() {
    this.props.removeCustomField(this.props.index);
  }

  componentDidMount() {
    ReactDOM.findDOMNode(this.refs.nameInput).focus();
  }

  render() {
    return (
      <React.Fragment>
        <Col xs={3}>
          <FormGroup>
            <FormControl
              ref="nameInput"
              id="name"
              name="name"
              style={{ borderColor: this.props.valid ? "grey" : "red" }}
              className="s-input-field"
              type="text"
              placeholder={t("Key")}
              value={this.name}
              onChange={event => this.updateName(event)}
            />
          </FormGroup>
        </Col>
        <Col xs={8}>
          <PillInput
            id="allowed_values"
            name="allowed_values"
            className="s-input-field"
            type="text"
            placeholderText={t("Enter values (comma-separated)")}
            pills={this.allowedValues}
            onChangeCallback={pillState => this.updateAllowedValues(pillState)}
          />
        </Col>
        <Col xs={1}>
          <div
            className="s-remove-controlled-custom-field"
            onClick={() => this.removeCustomField()}
          >
            <i className="fa fa-times" />
          </div>
        </Col>
      </React.Fragment>
    );
  }
}
